(function () {
  "use strict";

  DeleteCourseCtrl.$inject = ['$scope', '$rootScope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('DeleteCourseCtrl', DeleteCourseCtrl);

  function DeleteCourseCtrl($scope, $rootScope, $timeout) {
    $scope.modal = {
      content: 0,
      data: {},
      status: '',
      confirmed: false
    };

    $scope.deleteCourse = function () {
      $scope.modal.status = 'saving';
      $scope.modal.confirmed = true;
      $rootScope.$broadcast('courseDeletionConfirmedEvent', $scope.modal.data, function () {
        $scope.dismiss();
        $timeout(function () {
          $scope.modal.status = ''
        }, 500);
      });
    };

    $scope.$on('courseDeletionRequestedEvent', function (event, course) {
      $scope.modal.status = '';
      $scope.modal.data = course.id;
      $scope.modal.content = course.name;
      $scope.modal.confirmed = false;
      $scope.show();
    });

  }

})();
